export default "__VITE_ASSET__d$LktbJk__"